module.exports = __webpack_public_path__ + "v3/Roboto-Regular.a8d6ac03.ttf";